import CommentsWidget from './CommentsWidget';
export default CommentsWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/CommentsWidget/index.js